module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_iterators.js
// module id = 18
// module chunks = 0